import { ClienteProdutoConteudo } from '../../../../../../../types/cliente-produto';
import { CollapsibleSection } from './collapsible-section';
import { Row } from './styles';

interface Props {
  data: ClienteProdutoConteudo;
}

export const ConteudoSection = ({ data }: Props) => (
  <CollapsibleSection
    title="Conteúdo e suporte"
    defaultOpen
    testId="produto-section-conteudo"
  >
    <Row>
      <span>Página de vendas</span>
      <span>
        {data.paginaVendas ? (
          <a
            href={data.paginaVendas}
            target="_blank"
            rel="noreferrer noopener"
          >
            {data.paginaVendas}
          </a>
        ) : (
          '—'
        )}
      </span>
    </Row>
    <Row>
      <span>E-mail suporte</span>
      <span>{data.emailSuporte ?? '—'}</span>
    </Row>
    <Row>
      <span>Nome suporte</span>
      <span>{data.nomeSuporte ?? '—'}</span>
    </Row>
    {data.invoiceDescription && (
      <Row>
        <span>Descrição da fatura</span>
        <span>{data.invoiceDescription}</span>
      </Row>
    )}
    {data.obs && (
      <Row>
        <span>Observações</span>
        <span>{data.obs}</span>
      </Row>
    )}
  </CollapsibleSection>
);
